import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account-label auth__label" }
const _hoisted_2 = { class: "radio-button" }
const _hoisted_3 = ["value", "name"]
const _hoisted_4 = {
  key: 0,
  class: "auth__field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Exclamation = _resolveComponent("Exclamation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            value: item.value,
            name: _ctx.modelName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
          }, null, 8, _hoisted_3), [
            [_vModelRadio, _ctx.value]
          ]),
          _createElementVNode("span", null, _toDisplayString(item.label), 1)
        ]))
      }), 256))
    ]),
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createVNode(_component_Exclamation),
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}